export default __webpack_public_path__ + "static/media/video1more.1ecc39b9.mp4";